import type { ValueMappingEntry } from '../../types';

/**
 * Shared constants and value mappings for route lists
 */

/**
 * PD-16797 — trip type badge labels for the Trips list Type column. Every
 * trip before service trips is a delivery trip, so `delivery` reads neutral
 * and `service` stands out.
 */
export const TRIP_TYPE_VALUE_MAPPING: Array<ValueMappingEntry> = [
	{
		value: 'delivery',
		displayText: 'Delivery',
		color: { type: 'neutral' },
	},
	{
		value: 'service',
		displayText: 'Service',
		color: { type: 'info' },
	},
];

/**
 * Trip status value mapping — shared across all Trips list views.
 *
 * Keep one entry per value in `TripStatus` (libs/shared/.../trip.entity.ts).
 * When a value is missing here the badge falls back to rendering the raw
 * snake_case enum, which surfaces to the user as "pending_load" instead
 * of "Pending Load". Three pending_* statuses were added 2026-05-12/13
 * (pending_load, pending_pre_trip_wm_review, pending_post_trip_wm_review)
 * and need their human labels here too.
 */
export const TRIP_STATUS_VALUE_MAPPING = [
	{
		value: 'pending_load',
		label: 'Pending Load',
		color: { type: 'warning' },
	},
	{
		value: 'pending_pre_trip_wm_review',
		label: 'Pending Pre-Trip Review',
		color: { type: 'warning' },
	},
	{
		value: 'scheduled',
		label: 'Scheduled',
		color: { type: 'info' },
	},
	{
		value: 'in-progress',
		label: 'In Progress',
		color: { type: 'info' },
	},
	{
		value: 'pending_post_trip_wm_review',
		label: 'Pending Post-Trip Review',
		color: { type: 'warning' },
	},
	{
		value: 'completed',
		label: 'Completed',
		color: { type: 'success' },
	},
	{
		value: 'failed',
		label: 'Failed',
		color: { type: 'danger' },
	},
	{
		value: 'cancelled',
		label: 'Cancelled',
		color: { type: 'neutral' },
	},
] as const;
